import React from 'react';
import { useLoaderData } from 'react-router-dom';
import ServiceReview from './ServiceReview';
import ServicesDetailsSection from './ServicesDetailsSection';
import ShowReview from './ShowReview';

const ServiceDetail = () => {
    const serviceDet =useLoaderData();
 
    console.log(serviceDet);
    return (
        <div>
            <ServicesDetailsSection></ServicesDetailsSection>
            <ServiceReview serviceDet={serviceDet}></ServiceReview>
            {/* <ShowReview></ShowReview> */}
        
        </div>
    );
};

export default ServiceDetail;